/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import ConfirmationBox from "../../../../../components/common/ConfirmationBox";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

import { contactinfo } from "../../../../../data/renewals";

import { RiAddCircleFill, RiCloseCircleLine } from "react-icons/ri";
import { months, packets, payee } from "./property";

import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Radio,
  Row,
  Select,
} from "antd";
import PostToWebsite from '../../../../../components/common/PostToWebsite';
import PostToInternet from '../../../../../components/common/PostToInternet';
import TextArea from "antd/es/input/TextArea";
import EmailRentalApplication from "../../../../../components/common/EmailRentalApplication";

function Property() {
  const [postToWebsiteOpen, setPostToWebsiteOpen] = useState(false);
  const [postToInternetOpen, setPostToInternetOpen] = useState(false);
  const [newOwnerShipShow, setNewOwnerShipShow] = useState(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [value, setValue] = useState("net income");
  const [inputFields, setInputFields] = useState([
    {
      ownerName: "",
      percent: "",
      date: "",
    },
  ]);
  const [totalPercentage, setTotalPercentage] = useState(0);

  const addInputField = () => {
    setInputFields([
      ...inputFields,
      {
        ownerName: "",
        percent: "",
        date: "",
      },
    ]);
    setTotalPercentage(totalPercentage + inputFields.percent);
  };

  const removeInputFields = (index) => {
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const list = [...inputFields];
    list[index][name] = value;
    setInputFields(list);
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const [isHidePropertyShow, setIsHidePropertyShow] = useState(false);

  const [textPropertyShow, setTextPropertyShow] = useState();
  const [count, setCount] = useState(0);

  const handleUrl = () => {
    window.open('/inspection', '_blank');
  }
  const PropertyRightbar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("New Property", "1", "", "", "/properties/new"),
      RightBarMethod("New Property Group", "2", "", "", "/generalsettings/new-property-groups"),
      RightBarMethod(
        <span onClick={() => setNewOwnerShipShow(true)}>New Ownership</span>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod("New Rentable Item", "4", "", "", ""),
      RightBarMethod("Move In Tenant", "5", "", "", "/people/tenants/move-in-tenant"),
      RightBarMethod("Increase Rent", "6", "", "", "/rent_increase"),
      RightBarMethod(<span onClick={() => setIsConfirmationBoxOpen(true)}>
      Email Rental Application
    </span>, "7", "", "", ""),
      RightBarMethod("New Service Request", "8", "", "", "/maintenance/work-orders/service-requests/new"),
      RightBarMethod("Work Orders", "9", "", "", "/maintenance/work-orders"),
      RightBarMethod("Purchase Orders", "10", "", "", ""),
      RightBarMethod(<a onClick={handleUrl}>New Inspection</a>,"11", "", "", ""),
      RightBarMethod("View Inspections", "12", "", "", ""),
      RightBarMethod("View Unit Turn Board", "13", "", "", ""),
      RightBarMethod(
        <span onClick={() => setTextPropertyShow(true)}>Text Property</span>,
        "14",
        "",
        "",
        ""
      ),
      RightBarMethod(<span onClick={()=>setIsHidePropertyShow(true)}>Hide Property</span>, "15", "", "", ""),
      RightBarMethod("End Management", "16", "", "", "/property-page/end-management"),
    ]),
    RightBarMethod("Marketing", "t2", <i className="fa-solid fa-globe"></i>, [
      RightBarMethod("Refresh Posting ", "17", "", "", ""),
      RightBarMethod(<span onClick={()=>setPostToWebsiteOpen(true)}>Post to Website</span>, "18", "", "", ""),
      RightBarMethod(<span onClick={()=>setPostToInternetOpen(true)}>Post to Internet</span>, "19", "", "", ""),
      RightBarMethod("Activate Premium Leads", "20", "", "", ""),
      RightBarMethod("Post Vacancy Manually", "21", "", "", ""),
      RightBarMethod("Download Marketing Flyer", "22", "", "", ""),
    ]),
    RightBarMethod(
      " REPORTS",
      "t3",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Property Directory", "23", "", "", "/"),
        RightBarMethod("Unit Directory", "24", "", "", "/"),
        RightBarMethod("Rent Roll", "25", "", "", "/"),
        RightBarMethod("Unit Vacancy Detail", "26", "", "", "/"),
        RightBarMethod("General Ledger", "27", "", "", "/"),
        RightBarMethod("Work Order", "28", "", "", "/"),
        RightBarMethod("Activities Summary", "29", "", "", "/"),
      ]
    ),
    RightBarMethod(
      " LETTERS",
      "t4",
      <i className="fa-solid fa-file-lines"></i>,
      [RightBarMethod("Send Statements", "30", "", "", "/")]
    ),
  ];
  return (
    <>
        <div className="property">
          <PageHeading heading="Property" />
        </div>
        <div className="RightSidebar">
          <RightBar RightBarData={PropertyRightbar} />
        </div>
    {
      postToWebsiteOpen ? <PostToWebsite setIsConfirmationBoxOpen={setPostToWebsiteOpen}></PostToWebsite> : null
    }
    {
      postToInternetOpen ? <PostToInternet setIsConfirmationBoxOpen={setPostToInternetOpen}></PostToInternet> : null
    }
      {newOwnerShipShow ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setNewOwnerShipShow}>
          <h2>New Ownership</h2>
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 11 }} colon={false}>
            <Row className="new-ownership" gutter={[0, 8]}>
              <Col span={24}>
                <Form.Item label="Ownership Start Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={22}>
                    <Row className="header-row">
                      <Col span={8}>
                        <span>Owner</span>
                      </Col>
                      <Col span={8}>
                        <span>Percent Owned</span>
                      </Col>
                      <Col span={6}>
                        <span>Contract Expires</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {inputFields.map((item, index) => {
                  return (
                    <Row align="middle" gutter={[18, 0]} className="data-row">
                      <Col span={22}>
                        <Row align="middle">
                          <Col span={8}>
                            <Select
                              style={{ width: "100%" }}
                              options={contactinfo}
                              placeholder="Start typing to search"
                              allowClear
                              showSearch
                            />
                          </Col>
                          <Col span={8}>
                            <InputNumber
                              placeholder="Enter Percent Owned"
                              name="percent"
                              value={item.percent}
                              onChange={(event) => handleChange(index, event)}
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={8}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Col>
                      {inputFields.length > 1 ? (
                        <Col span={2}>
                          <RiCloseCircleLine
                            size={22}
                            className="delete-icon"
                            onClick={() => removeInputFields(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  );
                })}
                <button
                  className="add-owner-btn"
                  onClick={() => addInputField()}
                >
                  <RiAddCircleFill size={18} /> <span>Add Another Owner</span>
                </button>
              </Col>
              <Col span={24}>
                <p className="center-text">Total: {totalPercentage}%</p>
              </Col>
              <Col span={24}>
                <p className="onclick-text">Create New Owner</p>
              </Col>
              <Col span={24}>
                <Form.Item label="Payment Type">
                  <Radio.Group onChange={onChange} value={value}>
                    <Radio value="net income">Net Income</Radio>
                    <Radio value="flat">Flat</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Reserve Funds" required>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Reserve Funds"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Vendor 1099 Payer">
                  <Select options={payee} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Fiscal Year End">
                  <Select options={months} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Basis for Owner Packets">
                  <Select options={packets} placeholder="Select" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className="action-buttons">
            <Button type="primary" onClick={() => setNewOwnerShipShow(false)}>
              Save
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setNewOwnerShipShow(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    {
      isHidePropertyShow ? <ConfirmationBox setIsConfirmationBoxOpen={setIsHidePropertyShow}>
        <h2>3 Warnings</h2>
        <ul className='hide-list'>
          <li><span>Hiding this property will also hide all tenants associated with it.</span></li>
          <li><span>View and complete open items for recently closed out properties on the <span className='onclick-text'>End Management</span> page.</span></li>
          <li><span>This Property has non zero account balances, outstanding bills, and outstanding charges.</span></li>
        </ul>
        <div className="action-buttons">
          <Button type='primary' onClick={()=>setIsHidePropertyShow(false)}>Hide</Button>
          <button className="cancel-btn" onClick={()=>setIsHidePropertyShow(false)}>Cancel</button>
        </div>
      </ConfirmationBox> : null
    }
      {textPropertyShow ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setTextPropertyShow}>
          <h2>Send Bulk Text</h2>
          {/* <p className="tenant-property">
            None of the tenants in this property will be able to receive this
            message. (<span className="onclick-text">Why?</span>)
          </p> */}
          <Form layout="vertical">
            <Form.Item label="Recipients" required>
              <TextArea
                rows={3}
                placeholder="William Sunken"
                defaultValue="William Sunken"
                disabled
              />
            </Form.Item>
            <Form.Item label="Message" required>
              <TextArea
                rows={3}
                onChange={(e) => setCount(e.target.value.length)}
                maxLength="300"
              />
            </Form.Item>
            <p>{count} / 300 Characters</p>
            <div className="action-buttons">
              <Button type="primary">Send</Button>
              <button className="cancel-btn">Cancel</button>
            </div>
          </Form>
        </ConfirmationBox>
      ) : null}

{isConfirmationBoxOpen ? (
        <EmailRentalApplication
          isConfirmationBoxOpen={isConfirmationBoxOpen}
          setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}
        />
      ) : null}
    </>
  );
}

export default Property;
